const nazwaCzesci = { t: 'Nazwa', name: 'nazwa-czesci' }
export default nazwaCzesci